import moment from 'moment';
import { IChildProp } from '../../../Form/type';
import {
  TBasicInfoResult,
  IDownloadBaiscInfomationProp,
} from '@intelligence/_config/enumeration/download';

export const BUSINESS_PLATFORM_MAP: any = {
  'console-DigitalRevenue': 'mscience',
  'console-PhysicalRevenue': 'npd',
  'console-MAU': 'newzoo',
  'console-LifeTimePlayers': 'newzoo',
};

export type TCommonSetting = 'aggregated' | 'separate';
export type TDeviceSetting = TCommonSetting | 'device';
export type TDownloadParamsBoolValue = 0 | 1;
export type TTime = 'daily' | 'weekly' | 'monthly';
export type TEditionSetting = 'aggregated' | 'edition';
export type TTimeSetting = TCommonSetting;
export type TRegionSetting = 'aggregated' | 'region' | 'market';
export type TSegmentSetting = TCommonSetting;
export type TPlatformSetting = TCommonSetting;
export type TGameSetting = TCommonSetting;
export type TAnchorsSetting = TCommonSetting;
export type TMobileStoreSourceTypeConnector = 'app_store' | 'google_play';
export type TMobileStoreSourceType = 'appstore' | 'googleplay';
export type TMobileStore =
  | 'appstore top free'
  | 'appstore top grossing'
  | 'googleplay top free'
  | 'googleplay top grossing'
  | 'googleplay top popular';
export type TGenreSetting = 'aggregated' | 'isByGenre' | 'isBySubGenre';
export type TEntityType = 'mobile' | 'pc' | 'console';
export type TGenre = 'mainsub' | 'sub' | 'main';
export type TGenreSource = 'appannie' | 'iegg';
export type TPerType = 'region' | 'market';
export type TMobileDataSource = 'appannie' | 'ogdb';
export type TBenchmarkMetrics = 'revenue' | 'download' | 'dau';
export type TBenchmarkPlatform = 'Both' | 'ios' | 'Android';
export type TSteamSource = 'ytg' | 'facebook' | 'twitch';
export type TBenchmarkTimeScale = 'lt' | '365d' | '30d';

type TBasicInformatrionProp = IChildProp & IDownloadBaiscInfomationProp;

interface IUniversalDownloadParams {
  downlaod_date_method?: TTimeSetting;
  region_method?: TRegionSetting;
  ratio_show?: TDownloadParamsBoolValue;
  download_segments?: string[];
  device?: string[];
  download_devices?: string[];
  select_top?: number;
  select_ids?: string[];
  source_download_device?: Record<string, string[]>;
  download_metrics?: string[];
  // 下面4个是时间筛选器的，也就是类型为datePicker
  dateRange?: string[];
  start_date?: string;
  end_date?: string;
  granularity?: string;
  genre_method?: TGenreSetting;
  entity_type?: TEntityType;
  genre_types?: TGenre[];
  genreSource?: TGenreSource;
  genre_source?: TGenreSource;
  region_type?: TPerType[];
  // bencmark mobile
  sources?: TMobileDataSource[];
  // bencmark mobile
  metrics?: TBenchmarkMetrics[];
  // bencmark mobile
  systems?: TBenchmarkPlatform[];
  steam_source?: TSteamSource[];
  time_scale?: TBenchmarkTimeScale[];
  platforms?: TMobileStoreSourceType[];
  date_type?: string;
  download_start_date?: string;
  download_end_date?: string;
  download_markets?: string[];
  game_method?: TGameSetting[];
  edition_method?: TEditionSetting;
  influencers_method?: TAnchorsSetting;
  platform?: TSteamSource[];
  source_type?: TSteamSource[];
  platform_method?: TPlatformSetting[];
  date_method?: TCommonSetting;
  date_type_list?: TTime[];
  // following pc game current
  data_method?: TCommonSetting;
  // compare mobile
  download_date_type?: TTime[];
  device_method?: TDeviceSetting;
  segment_method?: TCommonSetting;
  // 手游详情页stats
  metric?: string[];
  data_sources?: string[];
}

/**
 * 针对直接取值，无需处理的map
 */
const UNIVERSAL_DOWNLOAD_MAP: any = {
  source: 'sources',
  mobileSource: 'data_sources',
  benchmarkMetrics: 'metrics',
  metrics: 'download_metrics',
  streamSource: 'steam_source',
  timeScale: 'time_scale',
  platform: 'platform',
  dataSettings: 'source_type',
  specialDataSettings: 'metric',
  dataSource: 'data_sources',
  timeSettings: 'downlaod_date_method',
  dateSettings: 'date_method',
  regionSettings: 'region_method',
  special_segmentSettings: 'download_segments',
  genreSettings: 'genre_method',
  marketSettings: 'region_type',
  overlapPlatformSettings: 'platforms',
  gameSettings: 'game_method',
  editionSettings: 'edition_method',
  anchorsSettings: 'influencers_method',
  platformSettings: 'platform_method',
  timeSettingsByTime: 'date_type_list',
  special_timeSettings: 'data_method',
  timeSettingsDateType: 'download_date_type',
  deviceSettings: 'device_method',
  segmentSettings: 'segment_method',
  gamePlatform: 'entity_type',
  dataCategory: 'download_metrics',
  genre: 'genre_types',
  platformSettingsNPD: 'npd',
  platformSettingsGSD: 'gsd',
  platformSettingsMscience: 'mscience',
  platformSettingsFamitsu: 'famitsu',
};

/**
 * Basic information的统一处理方法，已勾选的选项会处理成1或0传至后端
 * @param selectedList 选中的列表，受TBasicInfoParams制约
 * @returns
 */
export const getBasicInformationParams = (selectedList: TBasicInfoResult[], config: any) => {
  const result: Partial<Record<TBasicInfoResult, TDownloadParamsBoolValue>> = {};
  const targeBasicInfoConfig =
    config.find((item: IChildProp) => item.value === 'basicInformation') || {};
  // 如果整个都没展示，就不传
  if (!targeBasicInfoConfig.isShow) return {};
  // 目标配置，isShow不管有没有选中，都要传
  targeBasicInfoConfig?.children?.forEach((item: TBasicInformatrionProp) => {
    if (item.isShow) {
      // 比对有无选中，因没选中的不会到selectedList
      const isIn = selectedList?.includes(item.value) || false;
      result[item.value] = isIn ? 1 : 0;
    }
  });
  // console.log(result);
  return result;
};

/**
 * File Format的统一处理方法
 * @param target 值
 * @returns
 */
export const getFileFormatParams = (target: 'excel' | 'csv') => ({
  file_format: target === 'excel' ? 0 : 1,
});

export const getMetricsParams = (configs: any = [], target: any = {}) => {
  // console.log(configs, target);
  const sourceMap: any = {};
  const metricsResult: any = {};
  for (const sourceItem of configs) {
    for (const metricItem of sourceItem?.children || []) {
      const { source = '', value } = metricItem || {};
      sourceMap[`${source}###${value}`] = metricItem;
    }
  }
  for (const sourceName of Object.keys(target)) {
    for (const metricName of target[sourceName] || []) {
      const { source, interfaceSource } = sourceMap[`${sourceName}###${metricName}`] || {};
      const targetSource = interfaceSource || source;
      if (targetSource) {
        if (!Object.prototype.hasOwnProperty.call(metricsResult, targetSource))
          metricsResult[targetSource] = [];
        metricsResult[targetSource].push(metricName);
      }
    }
  }
  return metricsResult;
};

export const getMetricsParamsWhenSingleLevel = (configs: any = [], target: any = []) => {
  // console.log(configs, target);
  const metricsResult: any = {};
  for (const formItem of configs) {
    const { interfaceSource, source, value, isShow } = formItem || {};
    const trueSource = interfaceSource || source;
    if (target?.includes(value) && isShow) {
      if (!Object.prototype.hasOwnProperty.call(metricsResult, trueSource))
        metricsResult[trueSource] = [];
      metricsResult[trueSource].push(value);
    }
  }
  return metricsResult;
};

const getPlatformDownloadDevice = (config: any, type: any, targetValue: string[] = []) => {
  const tmpPlatObj: any = {};
  const trueSource = BUSINESS_PLATFORM_MAP[type];
  if (!type || !trueSource!) return tmpPlatObj;
  for (const platChild of config) {
    const { value, source, isShow } = platChild || {};
    if (trueSource === 'all') {
      source.split(',').forEach((sourceKey: string) => {
        if (!Object.prototype.hasOwnProperty.call(tmpPlatObj, sourceKey)) {
          tmpPlatObj[sourceKey] = [];
        }
        if (targetValue?.includes(value) && isShow) {
          tmpPlatObj[trueSource].push(value);
        }
      });
    } else {
      if (!Object.prototype.hasOwnProperty.call(tmpPlatObj, trueSource)) {
        tmpPlatObj[trueSource] = [];
      }
      if (targetValue?.includes(value) && isShow) {
        tmpPlatObj[trueSource].push(value);
      }
    }
  }
  return tmpPlatObj;
};

const getConfigShow = (config: any, key: string) => {
  const findConfig = config.find((item: IChildProp) => item.value === key) || {};
  return {
    findConfig,
    isShow: !!findConfig?.isShow,
  };
};

/**
 * 将下载的参数转换为接口需要的参数格式(console榜单)
 * @param formValues 表单中的原始值
 * @returns 接口参数
 */
export const convertUniversalDownloadPopupParams = (
  formValues: any,
  additionalFields: any,
  config: any,
): IUniversalDownloadParams => {
  // console.log('convertUniversalDownloadPopupParams', formValues, config);
  const result: IUniversalDownloadParams = {};
  Object.keys(formValues).forEach((key: string) => {
    const target = formValues[key];
    const { findConfig, isShow } = getConfigShow(config, key);
    if (!isShow) return {};
    switch (key) {
      case 'basicInformation':
        Object.assign(result, getBasicInformationParams(target, config));
        break;
      case 'fileFormat':
        Object.assign(result, getFileFormatParams(target));
        break;
      case 'regionCountrySelectMultiple':
        result.download_region_type = target?.type;
        result.download_regions = Array.isArray(target?.value) ? target.value : [target?.value];
        break;
      case 'dataCalculation': {
        const children = findConfig?.children;
        if (isShow) {
          Object.keys(target)?.forEach((key) => {
            const isChildShow = getConfigShow(children, key)?.isShow;
            if (isChildShow) {
              switch (key) {
                case 'ratio':
                  result.ratio_show = target[key] ? 1 : 0;
                  break;
                case 'countrySettings':
                  result.download_markets = target[key]?.value;
                  break;
                case 'special_platformSettings': {
                  const platSetConfig = children?.find((item: IChildProp) => item.value === key);
                  const type = additionalFields.businessType;
                  result.device = target[key];
                  result.download_devices = target[key];
                  result.source_download_device = getPlatformDownloadDevice(
                    platSetConfig?.children,
                    type,
                    target[key],
                  );
                  break;
                }
                case 'genreCategory': {
                  const selectedGenreSource =
                    formValues.gamePlatform === 'mobile' ? target[key] : 'iegg';
                  result.genreSource = selectedGenreSource;
                  result.genre_source = selectedGenreSource;
                  break;
                }
                case 'benchmarkPlatformSettings':
                  result.systems = target[key].includes('Both') ? ['Android', 'ios'] : target[key];
                  break;
                case 'timePickerSettings': {
                  const {
                    type,
                    value: [startDate, endDate],
                  } = target[key];
                  const formattedStartDate = moment(startDate).format('YYYY-MM-DD');
                  const formattedEndDate = moment(endDate).endOf('month').format('YYYY-MM-DD');
                  result.date_type = type;
                  result.download_start_date = formattedStartDate;
                  result.download_end_date = formattedEndDate;
                  result.dateRange = [formattedStartDate, formattedEndDate];
                  break;
                }
                case 'special_dateSettings':
                  result.date_method = target[key];
                  if (result.date_method === 'separate') {
                    // download_date_type还是date_type_list？
                    result.download_date_type = target.special_dateSettingsByTime;
                  }
                  break;
                case 'mobileDateSettings':
                  result.downlaod_date_method = target[key];
                  if (result.downlaod_date_method === 'separate') {
                    // download_date_type还是date_type_list？
                    result.download_date_type = target.special_dateSettingsByTime;
                  }
                  break;
                case 'specialEditionSettings': {
                  const edition = target[key];
                  // edition_method的值比较特殊，不知道为啥是数组
                  result.edition_method =
                    formValues?.businessType === 'mobile-retention' ? edition : [edition];
                  break;
                }
                case 'regionCountrySelectMultiple': {
                  result.download_region_type = target[key]?.type;
                  result.download_regions = Array.isArray(target[key]?.value)
                    ? target[key]?.value
                    : [target[key]?.value];
                  break;
                }
                case 'platformSettingsNPD':
                case 'platformSettingsGSD':
                case 'platformSettingsMscience':
                case 'platformSettingsFamitsu': {
                  if (!Object.prototype.hasOwnProperty.call(result, 'source_download_device')) {
                    result.source_download_device = {};
                  }
                  if (target[key] && target[key].length > 0) {
                    result.source_download_device[UNIVERSAL_DOWNLOAD_MAP[key]] = target[key] || [];
                  }
                  break;
                }
                default:
                  if (UNIVERSAL_DOWNLOAD_MAP[key]) {
                    result[UNIVERSAL_DOWNLOAD_MAP[key]] = target[key];
                  }
                  break;
              }
            }
          });
        }
        break;
      }
      case 'mutilMetrics': {
        const metrics = getMetricsParams(config[0]?.children, target);
        Object.assign(result, {
          source_metrics: metrics,
        });
        break;
      }
      case 'singleMetrics': {
        const metrics = getMetricsParamsWhenSingleLevel(findConfig?.children, target);
        Object.assign(result, {
          source_metrics: metrics,
        });
        break;
      }
      case 'companiesMetrics': {
        const downloadMetrics: string[] = [];
        Object.keys(target).forEach((parentKey) => {
          if (parentKey === 'gameOwned') {
            downloadMetrics.push('gameOwned');
          }
          for (const childKey of target[parentKey] || []) {
            // 特殊逻辑
            if (childKey === 'pc_digitalRevenue') {
              downloadMetrics.push('pc_units');
            } else if (childKey === 'pc_pcu') {
              downloadMetrics.push('pc_acu');
            } else if (childKey === 'console_digitalRevenue') {
              downloadMetrics.push('console_units');
            }
            downloadMetrics.push(childKey);
          }
        });
        result.download_metrics = downloadMetrics;
        break;
      }
      case 'dataAmount': {
        if (target === 'all') {
          result.select_top = additionalFields.total || 0;
        } else if (target === 'top') {
          result.select_top = formValues.selectTop;
          // 特殊的逻辑，从外部传入specialFields取值合并，外面传什么就传入什么
        } else if (target === 'specialSelected') {
          Object.assign(result, additionalFields?.specialFields ?? {});
        } else {
          result.select_ids = additionalFields?.selectedIds?.map((item: any) => item.gameId) || [];
        }
        break;
      }
      // special开头表名这个key并不通用
      case 'special_datePickerSettings':
        if (target) {
          const [startDate = '', endDate = ''] = target?.value || [];
          const formattedStartDate = moment(startDate).format('YYYY-MM-DD');
          const formattedEndDate = moment(endDate).format('YYYY-MM-DD');
          result.dateRange = [formattedStartDate, formattedEndDate];
          result.start_date = formattedStartDate;
          result.end_date = formattedEndDate;
          result.granularity = target?.type;
        }
        break;
      case 'special_dataCalculationChange':
        result.ratio_show = target ? 1 : 0;
        break;
      case 'benchmarkPlatformSettings':
        result.systems = target?.includes('Both') ? ['Android', 'ios'] : target;
        break;
      case 'overlapMetrics':
        result.metrics = target;
        result.download_metrics = target;
        break;
      case 'platform':
        result.platform = target;
        result.source_type = target;
        break;
      default:
        if (UNIVERSAL_DOWNLOAD_MAP[key]) {
          result[UNIVERSAL_DOWNLOAD_MAP[key]] = target;
        }
        break;
    }
  });
  return result;
};
